import React from 'react'
import roadImg from './road.png'

function Stat({value, label}){
  return (
    <div className="text-center text-white">
      <div className="text-3xl md:text-4xl font-extrabold">{value}</div>
      <div className="text-sm mt-1 uppercase tracking-wider">{label}</div>
    </div>
  )
}

export default function Stats(){
  return (
    <section className="-mt-6">
      <div className="bg-center bg-cover" style={{backgroundImage:`url(${roadImg})`}}>
        <div className="bg-gradient-to-b from-black/40 to-black/30">
          <div className="max-w-6xl mx-auto px-6 py-12 md:py-20">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-0">
              <div className="p-8 border-t-0 border-b-0 md:border-r border-white/20">
                <Stat value="1.5 MİLYON" label="Taşınan Ürün (lbs)" />
              </div>
              <div className="p-8 border-t-0 border-b-0 md:border-r border-white/20">
                <Stat value="238 BİN" label="Kat Edilen Mil" />
              </div>
              <div className="p-8">
                <Stat value="50" label="Araç Filosu" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
